import { FC } from 'react';
import s from './emptyProfile.module.scss';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {
  isMyProfile: boolean;
  pageType: 'toys' | 'posts';
}
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  color: 'Black',
  size: 'large'
};
export const EmptyProfile: FC<Props> = ({
  isMyProfile,
  pageType
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const newPostHandler = async () => {
    await router.push(LinksEnum.POST_CREATE);
  };
  const storeHandler = async () => {
    await router.push(LinksEnum.EXPLORE);
  };
  const createToyHandler = async () => {
    await router.push(LinksEnum.USER_TOY_DRAFT);
  };
  return <div className={s.emptyProfile} data-sentry-component="EmptyProfile" data-sentry-source-file="EmptyProfile.tsx">
            <SpriteIcon className={s.emptyProfile__icon} name={'coming_soon'} colored width={232} height={232} data-sentry-element="SpriteIcon" data-sentry-source-file="EmptyProfile.tsx" />
            <h3 className={s.emptyProfile__title}>
                {tr({
        id: 'public.profile.empty.title'
      })}
            </h3>
            {isMyProfile && <>
                    <div className={s.emptyProfile__text}>
                        {tr({
          id: 'public.profile.empty.text'
        })}
                    </div>
                    <div className={s.emptyProfile__footer}>
                        {pageType === 'posts' ? <Button id='profile_page_new_post_button' {...defaultButtonProps} onClick={newPostHandler}>
                                {tr({
            id: 'btn.new.post'
          })}
                            </Button> : <>
                                <Button id='profile_page_store_button' {...defaultButtonProps} onClick={storeHandler}>
                                    {tr({
              id: 'btn.store'
            })}
                                </Button>
                                <Button id='profile_page_toys_button' {...defaultButtonProps} onClick={createToyHandler}>
                                    {tr({
              id: 'btn.create.toy'
            })}
                                </Button>
                            </>}

                    </div>
                </>}
        </div>;
};